var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.43 37L60.4537 73.5H20.5463L0.569985 37L20.5463 0.5L60.4537 0.500002L80.43 37Z",
    stroke: "#29A4CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileEmpty);
export default __webpack_public_path__ + "static/media/tileEmpty.75e0d4a8257cd833ee9484119796d444.svg";
export { ForwardRef as ReactComponent };